import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import Header from "./components/Header";
import Footer from "./components/Footer";
import Home from "./components/Home";
import Apropos from "./components/Apropos";
import Boutique from "./components/Boutique";
import Gallery from "./components/Gallery";
import ProduitDetails from "./components/ProduitDetails";
import Contact from "./components/Contact";

const DefaultLayout = ({ children }) => (
  <>
    <Header />
    <main>{children}</main>
    <Footer />
  </>
);

const App = () => {
  return (
    <Router>
      <Routes>
        <Route path="/" element={<DefaultLayout><Home /></DefaultLayout>} />
        <Route path="/apropos" element={<DefaultLayout><Apropos /></DefaultLayout>} />
        <Route path="/boutique" element={<DefaultLayout><Boutique /></DefaultLayout>} />
        <Route path="/contact" element={<DefaultLayout><Contact /></DefaultLayout>} />
        <Route path="/galerie" element={<DefaultLayout><Gallery /></DefaultLayout>} />
        <Route path="/produitDetails/:id" element={<DefaultLayout><ProduitDetails /></DefaultLayout>} />
      </Routes>
    </Router>
  );
};

export default App;
